import { observer } from 'mobx-react'
import React, { useId } from 'react'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { MarkerPin06Icon } from '@flowwai-frontend/design-system/icons'
import { LocationValue } from '@flowwai-frontend/shared/common-components'

import { useFitBoundsInMap } from '../../../hooks/useFitBoundsInMap'
import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import MapTooltip from '../../MapTooltip/MapTooltip'

interface Props {
   geoShape: LocationValue
}

const SiteLocationTool = (props: Props): React.ReactElement => {
   const { geoShape } = props

   const { mapsT } = useMapsUtilityContext()
   const { fitGeoShapeInBounds } = useFitBoundsInMap({ shouldAnimate: true })

   const tooltipId = useId()

   const hasCoordinates =
      geoShape.value instanceof Array ? geoShape.value.length : geoShape.value

   const onClick = (): void => {
      fitGeoShapeInBounds(geoShape)
   }

   return (
      <React.Fragment>
         <Button
            size={'Small'}
            hierarchy={Hierarchy.Tertiary}
            subVariant={SubVariant.Gray}
            className={'w-fit !rounded-xl shrink-0 hover:bg-gray-100'}
            onClick={onClick}
            isDisabled={!hasCoordinates}
            leftIcon={({ stroke }) => (
               <MarkerPin06Icon height={20} width={20} stroke={stroke} />
            )}
            data-tooltip-id={tooltipId}
         >
            {mapsT('siteLocation')}
         </Button>

         {hasCoordinates ? null : (
            <MapTooltip
               content={mapsT('noSelectedCoordinates')}
               tooltipId={tooltipId}
            />
         )}
      </React.Fragment>
   )
}

export default observer(SiteLocationTool)
